import { Contenuto, StatoContenuto } from '../types';

/**
 * Reel già girati ma ancora da programmare, per un cliente.
 *
 * È il dato "Registrati" della Dashboard, mostrato anche nella pagina
 * Videomaker: video confermato a mano dal videomaker (`videoRegistrato`) e
 * contenuto non ancora programmato/pubblicato/archiviato. Rispecchia il badge
 * verde "Registrato" della pagina Programmazione.
 *
 * I reel delle campagne ADV restano fuori: seguono un percorso a parte e non
 * vanno programmati nel piano editoriale.
 */
export const reelRegistratiDaProgrammare = (
  contenuti: Contenuto[],
  clienteId: string
): number =>
  contenuti.filter(
    (c) =>
      c.clienteId === clienteId &&
      c.videoRegistrato &&
      !c.campagnaAdv &&
      c.stato !== StatoContenuto.PROGRAMMATO &&
      c.stato !== StatoContenuto.PUBBLICATO &&
      c.stato !== StatoContenuto.ARCHIVIATO
  ).length;
